export default "__VITE_ASSET__BbB0ynBv__"